// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608040251/js/" + chunkId + "." + {"44":"f0fa590a","225":"13a564a9","481":"2d08a556","486":"a7a260e5","770":"9d53d1d7"}[chunkId] + ".0.20083664476390195.chunk.js";
};